import React from 'react';
import { withTranslation } from 'react-i18next';

import { Flex, Box, Text, Formik, ButtonFilled } from 'Components/Base';
import Loading from 'Components/Loading';

import FeedbackOption from '../FeedbackOption';
const { FormContainer, Form, FormikInput } = Formik;

const validateFeedbackReport =
  (t = (t) => t, options = []) =>
  ({ category, feedback }) => {
    const error = {};
    if (!category) {
      error.category = t('FEEDBACK_REPORT.REPORT.CATEGORY_REQUIRED');
    }
    if (category === options?.[options.length - 1]?.value && !feedback) {
      error.feedback = t('FEEDBACK_REPORT.REPORT.FEEDBACK_REQUIRED');
    }
    return error;
  };

const FeedbackReport = ({ t, onSubmit, feedbackOptions, loading }) => {
  return (
    <Flex width={1} flexDirection={'column'}>
      <Text textStyle={'heading4'}>{t('FEEDBACK_REPORT.REPORT.REPORT')}</Text>
      <Box mt={4}>
        <FormContainer
          onSubmit={onSubmit}
          initialValues={{ category: '', feedback: '' }}
          validate={validateFeedbackReport(t, feedbackOptions)}
        >
          <Form id="feedback-report-form">
            <FormikInput.Selection
              name={'category'}
              placeholder={t('FEEDBACK_REPORT.REPORT.SELECT_TOPIC_PLACEHOLDER')}
              options={feedbackOptions}
              renderItem={(option) => <FeedbackOption {...option} />}
              required
            />
            <Box pb={2} />
            <FormikInput.TextArea
              rows={7}
              rowsMax={7}
              name={'feedback'}
              placeholder={t('FEEDBACK_REPORT.REPORT.FEEDBACK_PLACEHOLDER')}
            />
            <ButtonFilled mt={4} width={1} type={'submit'} borderRadius="8px" disabled={loading}>
              {loading ? (
                <Loading width={20} height={20} />
              ) : (
                t('FEEDBACK_REPORT.REPORT.SUBMIT_REPORT')
              )}
            </ButtonFilled>
          </Form>
        </FormContainer>
      </Box>
    </Flex>
  );
};

export default withTranslation('feedback')(FeedbackReport);
